/**
 * @description 配件回收领奖记录页
*/

import React, { useState, useEffect, useRef } from 'react';
import   './index.scss';
import ListView from '@/components/AntListView';
import {hideLoading, showLoading} from "@/components/loading";
import {getDrawRecord, queryDefCode} from "@/api/projectManager_self";
import {Toast} from "antd-mobile";
import {objectToQueryParams} from "@/utils/publicFun";

const PartsRecovery = ()=> {
    const currentPage = useRef(1)
    const [dataList, setDataList] = useState([])
    const [hasMore, setHasMore] = useState(false)
    const [isLoad, setIsLoad] = useState(false)

    useEffect(() => {
        window.JsBridge.setTitle('中奖记录');
        loadData();
    }, []);

    const onDidFocus = () => {
        window.JsBridge.addListener().then(() => {
        loadData();
      });
    }

    const loadData = async () => {
        currentPage.current = 1;
        try {
            showLoading();
            const res = await getDrawRecord({currentPage: currentPage.current, pageSize: 10});
            hideLoading();
            setIsLoad(true);
            if (res.code !== '000000') throw res.msg;
            if (!!res  && !!res?.data) {
                let { recordList = [] } = res.data
                setDataList(recordList)
                setHasMore(recordList.length >= 10)
            }
        } catch (error) {
            hideLoading();
            Toast.show(error);
        }

    }
    const loadMore = async () => {
        const res = await getDrawRecord({currentPage: currentPage.current+1, pageSize: 10});
        if (res.code !== '000000') throw res.msg;
        if (!!res && !!res?.data) {
            let { recordList = []} = res.data
            setDataList([...dataList, ...recordList])
            setHasMore(recordList.length >= 10)
            currentPage.current = currentPage.current + 1
        }
    }

    const addOrChangeAddress = (item) => {
        if(item.address) {
            item.prizeName = '罴九X上海申花精酿啤酒330ml*6瓶装';
            const param = objectToQueryParams(item);
            window.JsBridge.push('CustomWeb', { uri: `${process.env.REACT_APP_GKT_LINK}/front/activities/lottery/orderDetail?${param}`});
        }else {
            const param = objectToQueryParams({
                idf: 'goddessFes',
                activityCode: 'recovery202305',
                req: item.id,
                name: item.prizeName,
                imgUrl: item.prizeImgUrl,
                productId:item.skuId,
                isChangeName:1
            });
            window.JsBridge.push('CustomWeb', { uri:`${process.env.REACT_APP_GKT_LINK}/front/guapp/activityOrder?${param}`});
            onDidFocus();
        }
    }

    const renderItem = (item)=> {
        return (
            <div className={'record_itemContainer'}>
                <div className={'itemLeft'}>
                    <div className={'itemTop'}>
                        <div className={'itemTopTitle'}>
                            {`${item?.prizeName}`}
                        </div>
                    </div>
                    <div className={'itemTime'}>
                        {`${item?.time}`}
                    </div>
                </div >
                {
                    item?.prizeType === 3 &&
                    <div className={'itemAddressBtn'}>
                        <div className={'itemAddressBtnTitle'}
                            onClick={() => {addOrChangeAddress(item)}}>
                            {item.address ? `查看订单` : `填写地址领取奖品`}
                        </div>
                    </div>
                }
            </div>
        )
    }

    return (
        <div className={'receive_record_page'}>
            {/*<NFTHeader midText={'中奖记录'} shadow/>*/}
            <div className={'container_record_parts'}>
                <ListView
                    dataSource={dataList}
                    renderItem={renderItem}
                    hasMore={hasMore}
                    onRefresh={() => loadData()}
                    onEndReached={() => loadMore()}
                    style={{paddingTop: 120}}
                    isLoad={isLoad}
                />
            </div>
        </div>
    )
}

export default PartsRecovery
;
